export const viewQuery = `
SELECT 
    jb._id as id, 
    jb.name, 
    jbvh_latest.status, 
    jbvh_latest.last_updated_at, 
    jbvh_latest.last_success_at, 
    jbvh_latest.last_checked_at, 
    jbvh_latest.calculate_age
FROM
    jas_board_cache jb
    LEFT JOIN (
        SELECT *, ROW_NUMBER() OVER (
                PARTITION BY
                    jas_board_id
                ORDER BY last_checked_at DESC
            ) as rn
        FROM jas_board_verification_history_cache
    ) jbvh_latest ON jbvh_latest.jas_board_id = jb._id
    AND jbvh_latest.rn = 1
`;
